// NEW_FILE_JUSTIFIED: Pure utility functions for coverage page utilization display — extracted from MyCoveragePage for reuse across coverage components

/**
 * Get the Tailwind background color class for a utilization percentage.
 * green-500 (<=50%), orange-500 (50-80%), red-500 (>80%)
 */
export function getUtilizationColor(pct: number): string {
  if (pct > 80) return 'bg-red-500';
  if (pct > 50) return 'bg-orange-500';
  return 'bg-green-500';
}

/**
 * Get the Tailwind text color class matching the utilization bar fill.
 */
export function getUtilizationTextColor(pct: number): string {
  if (pct > 80) return 'text-red-500';
  if (pct > 50) return 'text-orange-500';
  return 'text-green-500';
}

/**
 * Safe utilization percentage (0-100).
 */
export function getUtilizationPercent(used: number, limit: number): number {
  if (limit <= 0) return 0;
  return Math.min(100, Math.round((used / limit) * 100));
}

const CURRENCY_NORMALIZE: Record<string, string> = {
  EUROS: 'EUR',
  EURO: 'EUR',
  DOLLARS: 'USD',
  DOLLAR: 'USD',
  POUNDS: 'GBP',
  POUND: 'GBP',
};

/**
 * Format a number as currency using the en-ZA locale.
 * Normalizes common non-ISO currency names (e.g. "EUROS" → "EUR").
 */
export function formatCurrency(amount: number, currency: string): string {
  const normalized = CURRENCY_NORMALIZE[currency.toUpperCase()] ?? currency;
  try {
    return new Intl.NumberFormat('en-ZA', { style: 'currency', currency: normalized }).format(
      amount
    );
  } catch {
    return `${normalized} ${amount.toLocaleString('en-ZA', { minimumFractionDigits: 2 })}`;
  }
}
